import { ValidationProblemDetails } from "hoksource";
import { DirectoryComponent } from "../directory-shared/DirectoryComponent";
import { Item } from "../models/entities/items/item";
import { ItemService } from "./ItemService";
import { CustomModelField } from "../models/entities/custom-field";
import { EditStateBase } from "../types/EditStateBase";
import { ItemTypes } from "./ItemTypes";
import React from "react";
import { ISyntheticEvent } from "hok-react";
import { Entity } from "../models/entities/entities/entity";


export class EditController extends DirectoryComponent<{},
EditStateBase<Item> &
{
    customFields:CustomModelField[]
}>
{

    constructor(props)
    {
        super(props);
        this.state = {
            input:{
                tag:"",
                type:ItemTypes.Inventory,
                unitCostCurrencyCode:"PHP",
                active:true,
                // fieldDetail:{}
            },
            customFields:[]
        };
    }



    id:string;
    
    componentDidMount()
    {
        this.id = this.getQueryParam("id");

        
        var customModel = this.context.data.customModels.find(e => e.name === "Item");
        var customFields = customModel?.fields ?? [];
        
        this.setState({customFields});
        if(this.id)
        {
                
            var service = new ItemService(this.context);

            service.find(this.id).then(e => {

                this.setState({
                    input:e
                });
            });

        }
    }

    handleDefaultVendorChange = (evt:ISyntheticEvent<{value:Entity}>) =>{

        var next = {...this.state.input, defaultVendorEntity: evt.target.value} as Item;

        if(next.defaultVendorEntity?.balanceDetail.currencyCode)
        {
            next.unitCostCurrencyCode = next.defaultVendorEntity.balanceDetail.currencyCode;
        }

        this.setState({input:next});
    };

    handleSubmit = async (evt:React.FormEvent<HTMLFormElement>)=>
    {

        
        evt.preventDefault();

        this.setState({
            errors:null,
            isSubmitting:true,
        });

        
        try
        {
            // success 
            var item = this.state.input;

                
            var service = new ItemService(this.context);

            await service.save({

                ...item,
                unitPrice:
                    item.unitPrice as any === "" ? null: item.unitPrice,
                    
                unitCost:
                item.unitCost as any === "" ? null: item.unitCost
            });

            this.history.goBack();

        }
        catch(err:any)
        {


            if(err.status === 400)
            {
                this.setState({errors:(err as ValidationProblemDetails).errors});
            }
        }


        this.setState({isSubmitting:false});
        
        

    }


}
